import axios from 'axios';
import { unitTypes, distanceRouteURL, googleMapAPI, directionsRouteURL } from '../../config';

export async function getDistanceAndDuration({ distanceType, locations }) {
    let result = { totalDistance: 0, totalDuration: 0, bookingLocations: [] }, origins = [], destinations = [], units = unitTypes[distanceType];
    let locationDistance = 0, locationDuration = 0, distanceData = [];
    if (!locations || locations.length < 2 || !units || !units.value || !google || !google.maps) return result;

    locations.map((location, index) => {
        if (index > 0) {
            destinations.push({
                waypoint: {
                    location: { latLng: { latitude: location?.lat, longitude: location?.lng } }
                }
            });
        }
        if (index < locations.length - 1) {
            origins.push({
                waypoint: {
                    location: { latLng: { latitude: location?.lat, longitude: location?.lng } }
                }
            });
        }
        result['bookingLocations'].push({
            id: location.id, //for edit locations, this value may or may not be exists
            location: location.location,
            locationLat: location.lat,
            locationLng: location.lng,
            locationStatus: location.locationStatus || 'pending',
            locationDistanceType: distanceType,
            locationType: index === 0 ? 'pickup' : ((index === locations.length - 1) ? 'drop' : 'stop'),
            locationDistance: 0,
            locationDuration: 0
        });
    });

    await google.maps.importLibrary('core');
    const response = await getDetailsFromGoogleMap({ units, destinations, origins })

    if (response?.data && response?.data?.length > 0) {
        response?.data.forEach((item) => {
            const { originIndex, destinationIndex, duration, distanceMeters } = item;
            if (originIndex === destinationIndex) {
                locationDuration = duration ? Number(duration.match(/\d+/)[0]) / 60 : 0;
                locationDistance = distanceMeters > 0 ? distanceMeters / units?.convertFromMeter : 0;

                distanceData.push({
                    locationDistance,
                    locationDuration
                });
                result['totalDuration'] += locationDuration;
                result['totalDistance'] += locationDistance;
            }
        });
    }

    result.bookingLocations = result?.bookingLocations.map((item, index) => {
        if (index == 0) {
            return {
                ...item,
                locationDuration: 0,
                locationDistance: 0,
            };
        } else {
            const { locationDuration, locationDistance } = distanceData[index - 1];
            return {
                ...item,
                locationDuration,
                locationDistance
            };
        }
    });

    return result;
}

export async function getDetailsFromGoogleMap({ units, destinations, origins }) {
    if (!destinations || !units || !units.value || !origins) return [];

    const requestData = {
        origins,
        destinations,
        travelMode: 'DRIVE',
        units: units?.value?.toUpperCase()
    }
    try {
        const response = await axios.post(distanceRouteURL, requestData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Goog-Api-Key': googleMapAPI,
                'X-Goog-FieldMask': 'originIndex,destinationIndex,status,condition,distanceMeters,duration'
            },
        });
        return response
    } catch (error) {
        return null
    }
}

export async function getMapDirections({ origin, destination, intermediates, distanceType }) {
    let units = distanceType && unitTypes[distanceType];
    const requestData = {
        origin,
        destination,
        intermediates,
        travelMode: 'DRIVE',
        units: units?.value?.toUpperCase()
    }
    try {
        const response = await axios.post(directionsRouteURL, requestData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Goog-Api-Key': googleMapAPI,
                'X-Goog-FieldMask': 'routes'
            },
        });

        return response;
    } catch (error) {
        return null
    }
}


